import { $identity } from "@/services/apis/";

export const listTimezones = () => {
  return $identity.get(`/api/v1/time_zones`);
};
